import React, { useState, useEffect } from 'react';
import './App.css';
import ComingSoonUI from './components/ComingSoonUI';
import DingoLandingPage from './components/DingoLandingPage';
import { features } from './config/features';

function App() {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    // Détecte la langue du navigateur
    const userLanguages = navigator.languages || [navigator.language];
    const userLang = userLanguages[0].split('-')[0];
    if (userLang === 'fr') {
      setLanguage('fr');
    }
  }, []);

  return features.isComingSoonEnabled ? (
    <ComingSoonUI 
      language={language} 
      onLanguageChange={setLanguage} 
    />
  ) : (
    <DingoLandingPage 

    />
  );
}

export default App;
